import { forwardRef, HTMLAttributes } from "react";
import * as SC from "./active-bar.styles";

export interface ActiveBarProps extends HTMLAttributes<HTMLDivElement> {
  percent: number;
}

export const ActiveBar = forwardRef<HTMLDivElement, ActiveBarProps>(
  ({ className, style, children, ...props }, ref) => {
    return (
      <SC.Bar ref={ref} className={className} style={style} {...props}>
        {children}
      </SC.Bar>
    );
  }
);

ActiveBar.displayName = "ProgressBarFullWidth.ActiveBar";
